import { axiosConfigBuilder } from '..';

export class CrossMediaService {
  async getPublishers(token, countryCodeDetails) {
    const getPublishersResponse = await axiosConfigBuilder(token).post(
      '/get_cmp_publishers',
      countryCodeDetails
    );
    return getPublishersResponse.data;
  }

  async getCrossMediaPresetValues(token, crossMediaDefaultValuesDetails) {
    const getCrossMediaPresetValuesResponse = await axiosConfigBuilder(
      token
    ).post('/get_cmp_preset_values', crossMediaDefaultValuesDetails);
    return getCrossMediaPresetValuesResponse.data;
  }

  async resetCustomMedia(token, customMediaDetails) {
    const resetCustomMediaResponse = await axiosConfigBuilder(token).post(
      '/reset_cmp_preset_values',
      customMediaDetails
    );
    return resetCustomMediaResponse.data;
  }

  async saveCurrentMedia(token, currentMediaDetails) {
    const saveCurrentMediaResponse = await axiosConfigBuilder(token).post(
      '/save_cmp_preset_values',
      currentMediaDetails
    );
    return saveCurrentMediaResponse.data;
  }

  async getPresets(token, presetsDetails) {
    const getPresetsResponse = await axiosConfigBuilder(token).post(
      '/get_cmp_presets',
      presetsDetails
    );
    return getPresetsResponse.data;
  }

  async addPresetToDatabase(token, presetDetails) {
    const addPresetToDatabaseResponse = await axiosConfigBuilder(token).post(
      '/add_cmp_preset',
      presetDetails
    );
    return addPresetToDatabaseResponse.data;
  }

  async deletePresetFromDatabase(token, presetDetails) {
    const deletePresetFromDatabaseResponse = await axiosConfigBuilder(
      token
    ).post('/delete_cmp_preset', presetDetails);
    return deletePresetFromDatabaseResponse.data;
  }
}
